import * as ajaxFunctions from "ajax-functions.js";

let flashboardApiURL = rootURL + 'flashboard/';

function htmlDecode( input ) {
	var doc = new DOMParser().parseFromString( input, "text/html" );
	return doc.documentElement.textContent;
}

export function refresh_caller() {
	window.interval_check_caller_paused = true;

	$.ajax({
		type: 'post',
		url: flashboardApiURL + 'get-caller-infos/',
		dataType: 'json',
		crossDomain: true,
		async: true,
        cache: false,
		/*headers: {

		}*/
		data: {
			'user_id': userID,
			'csrf_tk_bingomaker': csrf_token
		},
		/*success: function( json ) {
			// json = ajaxFunctions.sanitizeJsonResponse( json );
			json = JSON.parse( json );
		},*/
		error: function() {
			window.interval_check_caller_paused = false;
		},
		complete: function( json ) {
			var jsonContent = JSON.parse( json.responseText );

			if( jsonContent.result == 'success' ) {
				var data = jsonContent.data;

				if( data.caller !== false ) {
					if( $('#standby').hasClass('hide') === false ) {
						location.reload();
					} else {
						// Si la partie a été redémarré
						if( activeCaller.iteration !== data.caller.gameIteration ) {
							location.reload();
						}

						// Si la valeur active a changé
						if( data.current_case !== undefined ) {
							jsonTitleValue = activeCaller.type !== 2 ? data.current_case.title : data.current_case.value;

							// Si on a une nouvelle valeur on l'affiche
							if( activeCaller.currentValue.letter !== data.current_case.letter || activeCaller.currentValue.title !== jsonTitleValue ) {
								// Tirage précédent
								activeCaller.previousValue.letter = activeCaller.currentValue.letter;
								activeCaller.previousValue.title = activeCaller.currentValue.title;

								// $( '#previousPick .letter' ).fadeOut( 350, function() { $(this).text( activeCaller.previousValue.letter ).fadeIn( 350 ) } );
								$( '#previousPick .letter' ).text( activeCaller.previousValue.letter );

								if( activeCaller.type !== 2 ) {
									// $( '#previousPick .value' ).fadeOut( 350, function() { $(this).text( activeCaller.previousValue.title ).fadeIn( 350 ) } );
									$( '#previousPick .value' ).text( activeCaller.previousValue.title );
								} else {
									// $( '#previousPick .value' ).fadeOut( 350, function() { $(this).html( $( '#currentPick .value' ).html() ).fadeIn( 350 ) } );
									$( '#previousPick .value' ).html( $( '#currentPick .value' ).html() );
								}

								// Tirage courant
								activeCaller.currentValue.letter = data.current_case.letter;
								activeCaller.currentValue.title = jsonTitleValue;

								// $( '#currentPick .letter' ).fadeOut( 350, function() { $(this).text( activeCaller.currentValue.letter ).fadeIn( 350 ) } );
								$( '#currentPick .letter' ).text( activeCaller.currentValue.letter );

								if( activeCaller.type !== 2 ) {
									// $( '#currentPick .value' ).fadeOut( 350, function() { $(this).text( activeCaller.currentValue.title ).fadeIn( 350 ) } );
									$( '#currentPick .value' ).text( activeCaller.currentValue.title );
								} else if( data.current_case !== false ) {
									// $( '#currentPick .value' ).fadeOut( 350, function() { $(this).html( data.current_case.html.full ).fadeIn( 350 ) } );
									$( '#currentPick .value' ).html( data.current_case.html.full );
								}

								// Si besoin on va lire l'audio
								/*if( audioEnabled === 1 ) {
									let lowerLetter = $pick.letter.toLowerCase();

									if( projectType == 1 ) {
										let audioBaseUrl = rootURL + 'audio/draw/' + site_lang.substr( 0, 2 ) + '/';

										let audio_file = audioBaseUrl + lowerLetter + '/' + lowerLetter + $pick.text + '.mp3';
										window.callerVoice.src = audio_file;
										window.callerVoice.play();
									} else {
										let audioLetterUrl = rootURL + 'audio/letter/' + site_lang.substr( 0, 2 ) + '/',
											audioEmojiUrl = rootURL + 'audio/emoji/' + site_lang.substr( 0, 2 ) + '/',
											emojiHasPlayed = false;

										// On est dans un projet emoji, on va lire la lettre et ensuite le nom de l'emoji
										window.callerVoice.src = audioLetterUrl + lowerLetter + '.mp3';
										window.callerVoice.play();

										window.callerVoice.onended = function() {
											if( ! emojiHasPlayed ) {
												window.callerVoice.src = audioEmojiUrl + $pick.text + '.mp3';
												window.callerVoice.play();

												emojiHasPlayed = true;
											}
										};
									}
								}*/

								if( activeCaller.currentValue.letter !== undefined && activeCaller.currentValue.title !== undefined ) {
									// On enlève la case active dans le tableau et on mets le td en état actif
									$( '#drawTable .lastPick' ).removeClass( 'lastPick' );
									// $( '#drawTable .active' ).removeClass( 'active' );
									$( '#drawTable .current-active' ).removeClass( 'current-active' );

									// On mets la nouvelle valeur en current-active
									$( '#drawVal_' + data.current_case.value ).addClass('active uk-text-bold lastPick');

									// if( activeCaller.type === 1 ) {
										$( '#drawTable' ).parent().animate({
											scrollLeft: $( '#drawVal_' + data.current_case.value ).position().left - 45,
											scrollTop: $( '#drawVal_' + data.current_case.value ).position().top - 45
										}, 150);
									// } else {
									// 	$( '#drawTable' ).parent().animate({
									// 		scrollTop: $( '#drawVal_' + data.current_case.value ).position().top - 45
									// 	}, 150);
									// }
								}

							}

							// console.log( data.caller.idCodesList !== null );
							if( data.caller.idCodesList !== null ) {
								data.flashboard.password = 0;
							}
						}

						// Si les valeur du flashboard on changé
						update_flashboard_elements_visibility( data.flashboard, data.flashboard_image );
					}
				} else if( $('#standby').hasClass('hide') !== false ) {
					location.reload();
				} else {
					update_flashboard_standby_image( data.flashboard_image.bg );
				}
			}

			window.interval_check_caller_paused = false;

			csrf_token = jsonContent.csrf;
		}
	});
}

function update_flashboard_elements_visibility( flashboard, flashboard_image ) {
	if( flashboard !== null ) {
		if( flashboard.game_info == 1 ) {
			$('#board-game-info').removeClass('hide');
		} else {
			$('#board-game-info').addClass('hide');
		}

		if( flashboard.bottom_image == 1 ) {
			$('#board-bottom-image').removeClass('hide');
		} else {
			$('#board-bottom-image').addClass('hide');
		}

		if( flashboard.password == 1 ) {
			$('#board-password').removeClass('hide');
		} else {
			$('#board-password').addClass('hide');
		}

		if( flashboard.patterns == 1 ) {
			$('#board-patterns').removeClass('hide');
		} else {
			$('#board-patterns').addClass('hide');
		}

		if( flashboard.qr_code == 1 ) {
			$('#board-qr-code').removeClass('hide');
		} else {
			$('#board-qr-code').addClass('hide');
		}

		if( flashboard.voice == 1 ) {
			$('#board-voice').removeClass('hide');
		} else {
			$('#board-voice').addClass('hide');
			// window.audio_enabled = false;
		}

		if( flashboard_image.bottom !== false ) {
			$('#board-bottom-image-img').attr( 'src', flashboard_image.bottom );
		}

		update_flashboard_standby_image( flashboard_image.bg );
	}
}

function update_flashboard_standby_image( bg ) {
	if( bg !== false ) {
		$('#standby').css( 'background-image', "url(" + bg + ")" );
	}
}